<template>
    <div>
        <div class="card-body">
            <el-form label-position="left" label-width="80px">
                <el-row :span="20">
                    <el-col :span="20">
                        <el-form-item label="缺勤原因:">
                            <el-select
                                    v-model="$parentInfo.studentPeriod.absentPeriod.status"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="请假类型:" v-if="$parentInfo.studentPeriod.absentPeriod.status=='leaving'">
                            <el-select
                                    v-model="use_status_type"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in status_types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="primary" size="small" @click="handleAbsentClassInAbsent()"
                           :loading="$parentInfo.studentPeriod.absentPeriod.button_loading">
                    保存
                </el-button>
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        data() {
            return {
                options: [
                    {
                        value: 'absent',
                        label: '缺席'
                    },
                    {
                        value: 'leaving',
                        label: '请假'
                    },
                    {
                        value: 'orgReason',
                        label: '机构原因'
                    },
                    {
                        value: 'truancy',
                        label: '旷课'
                    },
                ],
                status_types:[
                    {
                        value:1,
                        label:'个人原因'
                    },
                    {
                        value:2,
                        label:'病假'
                    },
                    {
                        value:3,
                        label:'个人社会实践'
                    },
                    {
                        value:4,
                        label:'学校集体活动'
                    },
                ],
                dialogVisible: false,
                use_status_type:'',
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        props: {
            classPlanStudent_id: {
                default: 0,
            },
            student_id: {
                default: 0,
            },
        },
        methods: {
            handleAbsentClassInAbsent() {
                this.$parentInfo.studentPeriod.absentPeriod.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'activeAndAbsentClass', {
                    'classPlanStudent_id': this.classPlanStudent_id,
                    'reason': '',
                    'status': this.$parentInfo.studentPeriod.absentPeriod.status,
                    'student_id': this.student_id,
                    'use_status_type': this.use_status_type,
                });
            },
            changeClassesPlan() {
                this.$store.commit('modal', {dialog: ''});
                this.$Win.openModal('Dialog_ChangeClassPlan',1000,900, '', {
                    'classPlanStudent_id': this.classPlanStudent_id,
                    'reason': '',
                    'status': this.$parentInfo.studentPeriod.activePeriod.status,
                    'student_id': this.student_id,
                    'class_name': this.class_name
                }, true);

            },
        }
    };
</script>

<style scoped>

</style>
